import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ParentLoginPage from './non-logged/ParentLoginPage';
import StudentLoginPage from './non-logged/StudentLoginPage';
import ParentSignupPage from './non-logged/ParentSignupPage';
import ErrorBoundary from './parts/Error/ErrorBoundary';

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 24 }}>
      {children}
    </Typography>
  );
}

const styles = theme => ({
  appBar: {
    color: '#000',
    backgroundColor: '#fff',
    boxShadow: 'none',
    borderBottom: '1px solid #eee',
  },
  content: {
    padding: 32,
  },
  tabs: {
    marginTop: 20,
  },
});

class DesktopNonLoggedPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event, tabIndex) {
    this.setState({ tabIndex });
  }

  render() {
    const {
      tabIndex,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <ErrorBoundary location="DesktopNonLoggedPage.js">
        {appType === 'parent'
          && (
          <div>
            <Tabs
              className={classes.tabs}
              value={tabIndex}
              onChange={this.handleChange}
              centered
            >
              <Tab label={t('Log In')} />
              <Tab label={t('Sign Up')} />
            </Tabs>
            {tabIndex === 0
              && (
              <TabContainer>
                <ParentLoginPage useSuspense={false} />
              </TabContainer>
              )
            }
            {tabIndex === 1
              && (
              <TabContainer>
                <ParentSignupPage useSuspense={false} />
              </TabContainer>
              )
            }
          </div>
          )
        }
        {appType === 'student'
          && (
          <div>
            <TabContainer>
              <StudentLoginPage useSuspense={false} />
            </TabContainer>
          </div>
          )
        }
      </ErrorBoundary>
    );
  }
}

export default withStyles(styles)(withTranslation()(DesktopNonLoggedPage));
